export default {"src":"/_next/static/media/xls-svgrepo-com.c5ebd8d8.svg","height":303,"width":303,"blurWidth":0,"blurHeight":0};